import { FieldLabel } from "./ui";

const HTTP_URL_RE = /^https?:\/\//i;

/** Audit reasoning callout — matches Phase 4 project detail. */
export function PdrReasoningBlock({
  text,
  quote,
  sourceUrl,
}: {
  text: string;
  quote?: string;
  sourceUrl?: string;
}) {
  const safeUrl = sourceUrl && HTTP_URL_RE.test(sourceUrl) ? sourceUrl : "";
  return (
    <div className="mt-2 pl-3 border-l-2 border-tertiary/50 bg-tertiary/5 rounded-r py-2 pr-3">
      <FieldLabel className="text-tertiary mb-1">Reasoning</FieldLabel>
      <p className="text-body-sm text-on-surface-variant leading-relaxed whitespace-pre-wrap">
        {text}
      </p>
      {quote ? (
        <p className="mt-2 pl-2 border-l-2 border-outline-variant text-body-sm text-on-surface-variant/90 italic leading-relaxed whitespace-pre-wrap">
          “{quote}”
        </p>
      ) : null}
      {safeUrl ? (
        <a
          href={safeUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-1 inline-block text-[11px] text-primary underline break-all"
        >
          {safeUrl}
        </a>
      ) : null}
    </div>
  );
}
